import { FormGroup, FormGroupFeedback, IFormGroupProps, Intent, ISwitchProps, Switch } from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField, useFormikContext } from 'formik';
import * as React from 'react';

export interface ISwitchFieldProps {
  name: string;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
  submitOnChange?: boolean;
  switchProps?: Omit<ISwitchProps, 'intent'>;
  handleChange?(checked: boolean): void;
}

export default function SwitchField<T extends boolean>({
  name,
  formGroupProps,
  handleChange,
  submitOnChange,
  switchProps,
}: ISwitchFieldProps) {
  const { submitForm } = useFormikContext();
  const [field, meta, helpers]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
  const hasError = meta.touched && meta.error;

  const onChange = (event: React.FormEvent<HTMLInputElement>) => {
    if (handleChange) {
      handleChange(event.currentTarget.checked);
    }
    helpers.setValue(event.currentTarget.checked as T);
    if (submitOnChange) submitForm();
  };

  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      <Switch checked={field.value} onChange={onChange} {...switchProps} />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
    </FormGroup>
  );
}
